import React from "react";
import { circle_add } from "../icons/circle_add";
import { description_icon } from "../icons/Description";
import { exit_icon } from "../icons/exit";
import { EmptyStarIcon, FullStarIcon } from "../icons/star";
import { useAuth } from "../store/authProvider";
import ConvertToArabicNumbers from "../utils/convert_numbers";
import Client from "../utils/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useEffect } from "react";

const ShowModal = ({
  offer,
  setShowModal,
  setShowContactModal,
  setShowOrderModal,
  states,
  cities_data,
  markets_data,
  type,
  offertype,
  favoriteOffers,
}) => {
  const { isAuth } = useAuth();

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (newTodo) => {
      return Client.post(`/favorites/${offer.id}`, { favorite_type: "offer" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("favorites");
    },
  });
  const navigator = useNavigate();
  const addFavorites = async () => {
    // Client.post(`/favorites/${offer.id}`, { favorite_type: "offer" });

    mutation.mutate();
  };
  let modalRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (!modalRef.current.contains(e.target)) {
        setShowModal(false);
        console.log(modalRef.current);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const user_id = localStorage.getItem("user_id");
  console.log(offer.type);
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0, transition: { duration: 0.1 } }}
        transition={{ duration: 0.2 }}
        className="fixed inset-0 z-[10000] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      >
        <div className="relative max-w-3xl w-[350px] mx-auto my-6">
          {/*content*/}
          <div
            className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none"
            ref={modalRef}
          >
            {/*header*/}
            <div className="flex items-center justify-center p-5 rounded-t border-slate-200 ">
              <div className="w-full flex items-center justify-between">
                <div
                  className="text-red-600 w-8"
                  onClick={() => setShowModal(false)}
                >
                  {exit_icon}
                </div>
                <div
                  className={`${type === "متوفر" ? "bg-primary" : "bg-amber-500"
                    } w-20 h-8  rounded-full text-white flex justify-center items-center`}
                >
                  {type}
                </div>
                <div
                  className="text-gray-500 w-8 active:scale-110"
                  onClick={addFavorites}
                >
                  {favoriteOffers.map((e) => e.id).includes(offer.id)
                    ? FullStarIcon
                    : EmptyStarIcon}
                </div>
              </div>
            </div>
            {/*body*/}
            <div className="flex justify-center h-[150px] overflow-hidden bg-center bg-no-repeat bg-flipped-logo items-center">
              <img
                src={offer.subCategory.image}
                className="w-[192px] self-center h-full object-contain "
                alt=""
              />
            </div>

            <div className="w-full flex justify-center items-center font-bold mt-2 text-lg">
              {offer.subCategory.name}
            </div>

            <div className="relative flex-auto px-3 border-2 my-7 mx-3 rounded-lg">
              <div className="flex flex-col gap-2 my-3" dir="rtl">
                <ModalTable
                  description="الوصف  "
                  value={ConvertToArabicNumbers(offer.offer)}
                  icon={description_icon}
                />
                <ModalTable
                  description="الولاية  "
                  value={states.find((e) => e.id === offer.state).name}
                />

                {offer.city && (
                  <ModalTable
                    description="المدينة  "
                    value={cities_data.find((e) => e.id === offer.city).name}
                  />
                )}
                {offer.market && (
                  <ModalTable
                    description="السوق  "
                    value={markets_data.find((e) => e.id === offer.market).name}
                  />
                )}
                <ModalTable
                  description="الكمية  "
                  value={`${ConvertToArabicNumbers(offer.quantity)} ${offer._unit.name
                    }`}
                />
                {offer.price && (
                  <ModalTable
                    description="السعر  "
                    value={`${offer.price} ${offer.currency === 'SDG' ? 'جنيه سوداني' : 'دولار أمركي'}`}
                  />
                )}
                {offer.price_per_unit && (
                  <ModalTable
                    description="سعر الوحدة   "
                    value={`${offer.price_per_unit} ${offer.currency === 'SDG' ? 'جنيه' : 'دولار'}   للـــ  (${offer._unit.name}) `}
                  />
                )}
              </div>
            </div>
            {/*footer*/}
            {/* <button
              className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
              type="button"
              onClick={() => (
                setShowModal(false),
                isAuth
                  ? (setShowContactModal(true),
                    Client.post("/admin/logs", {
                      user_id: isAuth ? user_id : null,
                      action: "Product Order",
                      product_type: "Crops Product",
                      product_id: offer.id.toString(),
                    }))
                  : navigator("/signin")
              )}
            >
              <div>طلب</div>
              {circle_add}
            </button> */}

            <button
              className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
              type="button"
              onClick={() => (
                setShowModal(false),
                isAuth
                  ? (setShowOrderModal(true),
                    Client.post("/admin/logs", {
                      user_id: isAuth ? user_id : null,
                      action: "Product Order",
                      product_type: "Crops Product",
                      product_id: offer.id.toString(),
                    }))
                  : navigator("/signin")
              )}
            >
              <div>

                {offertype === "sell" ? "طلب عرض سعر" : " تقديم عرض"}
              </div>
              {circle_add}
            </button>

          </div>
        </div>
      </motion.div>
      <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
    </>
  );
};

export default ShowModal;

const ModalTable = ({ description, value }) => {
  return (
    <div className="flex gap-4">
      <div className="flex">
        <div className=" text-sm w-[78px] leading-relaxed font-bold">
          {description}
        </div>
        <div className="text-black font-bold">:</div>
      </div>

      <div className="text-sm leading-relaxed font-bold ">{value}</div>
    </div>
  );
};
